document.addEventListener('DOMContentLoaded', function() {
    function lockQuantities() {
        // Get all cart item rows
        const cartItems = document.querySelectorAll('.cart__card');
        
        cartItems.forEach(item => {
            // Get the product title
            const titleElement = item.querySelector('.item__title a');
            if (!titleElement) return;
            
            const title = titleElement.textContent.toLowerCase();
            
            // Check if it's a box discount product
            if (title.includes('box discount')) {
                // Find and disable the quantity input
                const quantityInput = item.querySelector('.quantity-input');
                if (quantityInput) {
                    quantityInput.setAttribute('disabled', true);
                    quantityInput.style.opacity = '0.6';
                    quantityInput.style.cursor = 'not-allowed';
                }
                
                // Find and disable the plus/minus buttons
                const quantityButtons = item.querySelectorAll('.quantity-plus, .quantity-minus');
                quantityButtons.forEach(button => {
                    button.setAttribute('disabled', true);
                    button.style.opacity = '0.6';
                    button.style.cursor = 'not-allowed';
                });
            }
        });
    }

    // Run when page loads
    lockQuantities();
    
    // Run when cart updates (if using AJAX)
    document.addEventListener('cart:updated', lockQuantities);
});